import { Injectable } from '@angular/core';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';

import { Grupo } from './grupo';

@Injectable()
export class GrupoService {

  private grupoUrl = '/grupos';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) {

  }

  getAllGrupos(params?: any): Promise<Grupo[]> {
    let url:string = this.grupoUrl + "/all";
    return this.http.get(url, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as Grupo[])
                .catch((error) => this.handleError(error));
  }

  getGrupos(params?: any): Promise<Grupo[]> {

    return this.http.get(this.grupoUrl, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as Grupo[])
                .catch((error) => this.handleError(error));
  }

  getGrupo(id: number): Promise<Grupo>{
    let url: string  = this.grupoUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as Grupo)
               .catch((error) => this.handleError(error));
  }

  getUsuariosGrupo(id: number, params?: any): Promise<any[]> {
    let url:string = this.grupoUrl + "/usuariosGrupo/" + id;
    return this.http.get(url, {search: this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as any[])
                .catch((error) => this.handleError(error));
  }

  getAssinadoresGrupo(grupoId: number): Promise<any[]> {
    let url: string = this.grupoUrl + "/assinadores/" + grupoId;
    return this.http.get(url)
                .toPromise()
                .then(response => response.json().dados as any[])
                .catch((error) => this.handleError(error));
  }

  saveGrupo(grupo: Grupo): Promise<Response>{
    let url: string = this.grupoUrl;

    if(grupo.id !== undefined)
      url = url + '/' + grupo.id;

    return this.http
               .post(url, this.utils.buildFormData(grupo))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  addOrDelUsuarioGrupo(grupo_id:any, usuario_id:any, acao:any): Promise<Response>{
    let url: string = this.grupoUrl + '/addOrRemoveUsuarioGrupo';

    let dados: any = {grupo_id: grupo_id, usuario_id: usuario_id, acao: acao};

    return this.http
               .post(url, this.utils.buildFormData(dados))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  deleteGrupo(grupo: Grupo): Promise<Response>{
    let url: string = this.grupoUrl + '/' + grupo.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
          if(!Array.isArray(error.json().msg)){
            this.utils.flashMessage(error.json().msg, 'warning');
          }else{
            for(let msg of error.json().msg){
              this.utils.flashMessage(msg, 'warning');
            }
          }
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/grupos/grupo.service.ts